import * as React from "react";

function SvgMonitorChart({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M19.428 2.25a3.323 3.323 0 013.315 3.102l.007.219v8.857a3.323 3.323 0 01-3.102 3.315l-.219.007h-4.58l.313 2.5h.695a.75.75 0 01.102 1.493l-.102.007H8.143a.75.75 0 01-.102-1.493l.102-.007h.694l.313-2.5H4.571a3.322 3.322 0 01-3.316-3.133l-.005-.188V5.571a3.322 3.322 0 013.133-3.316l.188-.005h14.857zm-6.091 15.5h-2.675l-.313 2.5h3.301l-.313-2.5zm7.884-3H2.778a1.821 1.821 0 001.637 1.493l.156.007h14.858a1.821 1.821 0 001.758-1.346l.034-.154zm-1.793-11H4.571l-.15.006a1.822 1.822 0 00-1.665 1.666l-.006.149v7.679h18.5V5.571l-.007-.16a1.829 1.829 0 00-.418-1.01l-.109-.118-.118-.108a1.819 1.819 0 00-1.01-.418l-.16-.007zM12 6.25a.75.75 0 01.743.648L12.75 7v4l-.007.102a.75.75 0 01-1.486 0L11.25 11V7l.007-.102A.75.75 0 0112 6.25zm-4 1a.75.75 0 01.743.648L8.75 8v3l-.007.102a.75.75 0 01-1.486 0L7.25 11V8l.007-.102A.75.75 0 018 7.25zm8 1a.75.75 0 01.743.648L16.75 9v2l-.007.102a.75.75 0 01-1.486 0L15.25 11V9l.007-.102A.75.75 0 0116 8.25z"
        />
      </g>
    </svg>
  );
}

export default SvgMonitorChart;
